import React from 'react'
import './Styling.css'
export default function Aboutme() {
  return (
    <div className='Aboutme' id='Aboutme'>
        <h1>Hi,</h1>
        <p>
        I'm Wijdane CHARKAOUI ,An engineering student in computer science in National School of Applied Sciences Oujda,
        Also a  <b> FRONT-END </b> profile 
        .I've Created this portfolio to represent my projects in Web development using the Hand coding that respects web standards HTLM/CSS,pages dynamism by JAVASCRIPT also the responsive design ,
        and other technologies as REACT .
        </p>
        <button>
            <a href='https://drive.google.com/uc?export=download&id=1qZUS-xeQddmwvRRT8Ru0_Zs4qIvQpelP'>
            DOWNLOAD MY RESUME   
            </a>
        </button>
    </div>
  )
}
